import React from "react";
import "./TestimonialCard.css";

export function TestimonialCard({ name, text }: { name: string; text: string }) {
  return (
    <figure className="tCard">
      <div className="tQuote" aria-hidden="true">
        “
      </div>
      <blockquote className="tText">{text}</blockquote>
      <figcaption className="tName">{name}</figcaption>
    </figure>
  );
}